import React from 'react';
import { MdShowChart } from 'react-icons/md';
import InstrumentProfileModal from '../../components/common/InstrumentProfileModal';
import WatchListRow from './WatchListRow';
import WatchListRowCompact from './WatchListRowCompact';

/**
 * WatchListTable - Renders the instruments of a watchlist either as rich cards
 * ('card') or dense single-line rows ('compact'), toggled from the page header.
 * @param {Array} instruments
 * @param {Object} previousCloseMap - instrument_id -> previous close price
 * @param {Function} onRemoveInstrument
 * @param {'card'|'compact'} viewMode
 */
const WatchListTable = ({ instruments, previousCloseMap = {}, onRemoveInstrument, viewMode = 'card' }) => {
  const [profileInstrument, setProfileInstrument] = React.useState(null);
  const compact = viewMode === 'compact';

  return (
    <div className={`w-full pb-20 ${compact ? 'space-y-1' : 'space-y-4'}`}>
      {instruments && instruments.length > 0 ? (
        <>
          {/* Column headers — compact only, gives "Idle"/values their context */}
          {compact && (
            <div className="flex items-center gap-3 px-4 pb-1 text-[10px] font-semibold uppercase tracking-wide text-fg-3">
              <div className="flex-1 min-w-0 pl-3">Instrument</div>
              <div className="w-20 shrink-0">Exchange</div>
              <div className="hidden lg:block w-56 shrink-0">Type · Expiry · Roll</div>
              <div className="hidden md:block w-16 shrink-0 text-center">Algo</div>
              <div className="w-24 shrink-0 text-right">LTP</div>
              <div className="w-20 shrink-0 text-right">Chg %</div>
              <div className="w-[68px] shrink-0" aria-hidden="true" />
            </div>
          )}
          {instruments.map((inst, index) => {
          const key = inst.id || inst.instrument_id || index;
          const common = {
            inst,
            previousClose: previousCloseMap[inst.instrument_id],
            onRemoveInstrument,
            onViewProfile: setProfileInstrument,
          };
          return compact
            ? <WatchListRowCompact key={key} {...common} />
            : <WatchListRow key={key} {...common} />;
        })}
        </>
      ) : (
        <div className="flex flex-col items-center justify-center min-h-[400px]">
           <div className="relative">
             <div className="absolute inset-0 bg-primary blur-3xl opacity-10 rounded-full animate-pulse" />
             <MdShowChart className="relative text-9xl text-fg-3/30" />
           </div>
           <p className="mt-8 text-2xl font-black text-fg-3 tracking-widest uppercase">Start Monitoring</p>
           <p className="mt-2 text-sm text-fg-3 font-medium">Add instruments to track real-time algo performance</p>
        </div>
      )}

      {/* Profile Modal */}
      {profileInstrument && (
        <InstrumentProfileModal
          isOpen={!!profileInstrument}
          onClose={() => setProfileInstrument(null)}
          symbol={profileInstrument.symbol}
          exchange={profileInstrument.exchange}
        />
      )}
    </div>
  );
};

export default WatchListTable;
